import { gql } from '@apollo/client';

export const GET_IMPERSONATE_USER = gql`
  mutation ($userId: Int!) {
    user {
      impersonateUser(userId: $userId)
    }
  }
`;
